module.exports = __webpack_public_path__ + "media/60.cb39d196.wav";